import React, { useState } from 'react';
import { ReactComponent as IndiaSvg } from '../in.svg';
import './UserDashboard.css';

const DUMMY_DATA = {
  activeUsers: { activeNow: 103, total: 15550 },
  demography: {
    age: [
      { range: '18-24', percentage: 24 },
      { range: '25-34', percentage: 35 },
      { range: '35-44', percentage: 20 },
      { range: '45-54', percentage: 13 },
      { range: '55+', percentage: 8 },
    ],
    gender: [
      { type: 'Male', percentage: 60, color: '#166534' },
      { type: 'Female', percentage: 35, color: '#22C55E' },
      { type: 'Other', percentage: 5, color: '#86EFAC' },
    ],
    location: [
      { city: 'Ahmedabad', count: 4200, top: '52%', left: '22%' },
      { city: 'Jaipur', count: 3100, top: '40%', left: '30%' },
      { city: 'Delhi', count: 2800, top: '32%', left: '36%' },
      { city: 'Lucknow', count: 2400, top: '38%', left: '44%' },
      { city: 'Chandigarh', count: 1800, top: '26%', left: '34%' },
      { city: 'Vadodara', count: 1250, top: '56%', left: '24%' },
    ],
    maritalStatus: [
      { status: 'Single', percentage: 55, color: '#166534' },
      { status: 'Married', percentage: 36, color: '#22C55E' },
      { status: 'Divorced', percentage: 6, color: '#4ADE80' },
      { status: 'Widowed', percentage: 3, color: '#BBF7D0' },
    ],
    occupation: [
      { type: 'CA Student', percentage: 40, color: '#14532D' },
      { type: 'Professional', percentage: 30, color: '#166534' },
      { type: 'Business', percentage: 15, color: '#22C55E' },
      { type: 'Unemployed', percentage: 10, color: '#4ADE80' },
      { type: 'Retired', percentage: 5, color: '#BBF7D0' },
    ],
    jobStatus: [
      { status: 'Employed', percentage: 60, color: '#166534' },
      { status: 'Self-employed', percentage: 15, color: '#22C55E' },
      { status: 'Student', percentage: 20, color: '#4ADE80' },
      { status: 'Unemployed', percentage: 5, color: '#86EFAC' },
    ],
  },
  timeOfUsage: [
    { hour: '00', users: 120 }, { hour: '01', users: 85 }, { hour: '02', users: 45 },
    { hour: '03', users: 30 }, { hour: '04', users: 25 }, { hour: '05', users: 40 },
    { hour: '06', users: 95 }, { hour: '07', users: 180 }, { hour: '08', users: 320 },
    { hour: '09', users: 450 }, { hour: '10', users: 520 }, { hour: '11', users: 580 },
    { hour: '12', users: 490 }, { hour: '13', users: 420 }, { hour: '14', users: 480 },
    { hour: '15', users: 550 }, { hour: '16', users: 620 }, { hour: '17', users: 680 },
    { hour: '18', users: 750 }, { hour: '19', users: 820 }, { hour: '20', users: 890 },
    { hour: '21', users: 780 }, { hour: '22', users: 450 }, { hour: '23', users: 280 },
  ],
  conversationTopics: [
    { topic: 'CA Final Prep', intensity: 95 },
    { topic: 'CA Inter Doubts', intensity: 92 },
    { topic: 'Articleship Tips', intensity: 88 },
    { topic: 'GST Queries', intensity: 82 },
    { topic: 'Audit Standards', intensity: 78 },
    { topic: 'Income Tax Act', intensity: 75 },
    { topic: 'Accounts Concepts', intensity: 72 },
    { topic: 'ICAI Updates', intensity: 68 },
    { topic: 'Costing Problems', intensity: 62 },
    { topic: 'Law Sections', intensity: 58 },
    { topic: 'Exam Strategy', intensity: 52 },
    { topic: 'Career After CA', intensity: 45 },
  ],
  languages: [
    { language: 'Gujarati', percentage: 32, color: '#14532D' },
    { language: 'Marathi', percentage: 24, color: '#166534' },
    { language: 'Hindi', percentage: 22, color: '#22C55E' },
    { language: 'English', percentage: 12, color: '#4ADE80' },
    { language: 'Hinglish', percentage: 8, color: '#86EFAC' },
    { language: 'Punjabi', percentage: 2, color: '#BBF7D0' },
  ],
  intents: [
    { type: 'Doubts', count: 420, intensity: 90, icon: '❓' },
    { type: 'Guidance', count: 280, intensity: 75, icon: '🧭' },
    { type: 'Rant', count: 180, intensity: 60, icon: '😤' },
    { type: 'Casual Chat', count: 120, intensity: 45, icon: '💬' },
    { type: 'Motivation', count: 50, intensity: 30, icon: '🔥' },
  ],
  emotions: [
    { emotion: 'Happy', count: 380, percentage: 36, icon: '😊', color: '#14532D' },
    { emotion: 'Neutral', count: 320, percentage: 30, icon: '😐', color: '#166534' },
    { emotion: 'Anxious', count: 180, percentage: 17, icon: '😰', color: '#22C55E' },
    { emotion: 'Sad', count: 120, percentage: 12, icon: '😢', color: '#4ADE80' },
    { emotion: 'Mad', count: 50, percentage: 5, icon: '😡', color: '#86EFAC' },
  ],
  companions: [
    { name: 'Rahul', conversations: 2800, percentage: 26.7, color: '#14532D' },
    { name: 'Rohan', conversations: 2100, percentage: 20, color: '#166534' },
    { name: 'Mohan', conversations: 1680, percentage: 16, color: '#15803D' },
    { name: 'Amit', conversations: 1470, percentage: 14, color: '#22C55E' },
    { name: 'Sarthak', conversations: 1260, percentage: 12, color: '#4ADE80' },
    { name: 'Ejaz', conversations: 735, percentage: 7, color: '#86EFAC' },
    { name: 'Sahil', conversations: 455, percentage: 4.3, color: '#BBF7D0' },
  ],
  avgTimeSpent: { minutes: 15, seconds: 24 },
  insights: {
    focusGroups: [
      { group: 'CA Final Students (Nov Attempt)', priority: 'Critical', action: 'Push revision tips, mock test reminders, and stress management content' },
      { group: 'CA Inter Freshers', priority: 'High', action: 'Onboard with study plan templates and subject-wise guidance' },
      { group: 'Articleship Seekers', priority: 'High', action: 'Share firm listings, interview tips, and articleship FAQs' },
      { group: 'Working Professionals', priority: 'Medium', action: 'Provide quick GST/Tax updates and practical case studies' },
      { group: 'Gujarati-speaking Users', priority: 'Medium', action: 'Expand Gujarati content and regional exam center info' },
    ],
    topQueries: [
      { query: 'How to prepare for CA Final in 3 months?', count: 1240, trend: 'up' },
      { query: 'Best books for CA Inter Accounts', count: 980, trend: 'stable' },
      { query: 'Articleship stipend in Big 4', count: 870, trend: 'up' },
      { query: 'GST return filing process', count: 720, trend: 'stable' },
      { query: 'CA vs CMA vs CS comparison', count: 650, trend: 'down' },
      { query: 'How to handle articleship stress?', count: 580, trend: 'up' },
    ],
    contentInsights: [
      'CA Final revision content has 3x higher engagement than general topics',
      'Users prefer step-by-step explanations over summary answers',
      'Evening sessions (6-10 PM) show highest query complexity',
      'Gujarati users have 40% longer session times than average',
    ],
    companionInsights: [
      'Rahul is most popular for Tax & GST queries (32% of tax conversations)',
      'Rohan preferred by CA Inter students for Accounts doubts',
      'Mohan has highest satisfaction rating for Career Guidance',
      'Users who switch companions mid-session have 25% lower retention',
    ],
    retentionMetrics: [
      { metric: 'Day 1 Retention', value: 68 },
      { metric: 'Day 7 Retention', value: 42 },
      { metric: 'Day 30 Retention', value: 28 },
      { metric: 'Avg Sessions/User', value: 4.2 },
    ],
    peakInsights: [
      { finding: 'Sunday evenings have 2.5x more CA Final queries', relevance: 92 },
      { finding: 'Articleship queries spike in May-June (placement season)', relevance: 88 },
      { finding: 'GST queries increase around 20th of each month', relevance: 78 },
      { finding: 'Stress-related queries peak before exam results', relevance: 85 },
    ],
  },
};

const STATE_INSIGHTS = [
  { state: 'Gujarat', count: 8500, intensity: 'hot', cities: ['Ahmedabad', 'Vadodara', 'Himmatnagar'] },
  { state: 'Rajasthan', count: 4200, intensity: 'warm', cities: ['Jaipur'] },
  { state: 'Maharashtra', count: 3600, intensity: 'warm', cities: ['Pune'] },
  { state: 'Uttar Pradesh', count: 3100, intensity: 'warm', cities: ['Lucknow'] },
  { state: 'Delhi', count: 4100, intensity: 'warm', cities: ['Delhi'] },
  { state: 'Karnataka', count: 2900, intensity: 'cool', cities: ['Bengaluru'] },
];

const STATE_FILL = {
  Gujarat: '#f97316',
  Rajasthan: '#ef4444',
  Maharashtra: '#a855f7',
  'Uttar Pradesh': '#2563eb',
  Delhi: '#f43f5e',
  Karnataka: '#14b8a6',
};

const FIRST_NAMES_M = ['Rajesh','Amit','Vikram','Suresh','Rahul','Aakash','Nikhil','Sanjay','Deepak','Manoj','Karan','Arjun','Ravi','Rohit','Varun','Ajay','Pradeep','Gaurav','Ankit','Vishal','Mohit','Sachin','Pankaj','Ashish','Vivek','Kunal','Tarun','Harsh','Yash','Shubham','Neeraj','Rakesh','Dinesh','Ramesh','Mukesh','Hitesh','Jitesh','Paresh','Nilesh','Bhavesh'];
const FIRST_NAMES_F = ['Priya','Sneha','Anjali','Pooja','Neha','Kavita','Sunita','Meera','Anita','Rekha','Swati','Divya','Shruti','Nisha','Ritu','Geeta','Seema','Komal','Preeti','Manisha','Deepa','Shweta','Pallavi','Rashmi','Jyoti','Sapna','Aarti','Suman','Kiran','Archana'];
const LAST_NAMES = ['Kumar','Sharma','Patel','Singh','Reddy','Gupta','Verma','Joshi','Mehta','Shah','Agarwal','Mishra','Pandey','Yadav','Chauhan','Thakur','Saxena','Malhotra','Kapoor','Chopra','Bansal','Goel','Jain','Arora','Bhatia','Khanna','Sinha','Dutta','Ghosh','Nair'];
const OCCUPATIONS = ['CA Student','Working Professional','Business Owner','Freelancer','Consultant'];
const COMPANIONS = ['Rahul','Rohan','Mohan','Amit','Sarthak','Ejaz','Sahil'];
const MEMORIES = ['Preparing for CA Final','Likes cricket','Morning person','Works at Big 4','Night owl','Interested in audit','Runs business','GST queries frequent','Gujarati speaker','Telugu background','Struggles with accounts','Senior auditor','Work stress discussions','Fitness enthusiast','Loves reading','Tea lover','Coffee addict','Early riser','Weekend warrior','Music lover'];
const PREFS = ['Hindi','English','Hinglish','Gujarati','Tax topics','Career advice','GST topics','Accounting basics','Quick answers','Detailed explanations','Work-life balance','Practical examples'];
const FAMILY = ['Parents','Spouse','Son','Daughter','Siblings','Grandmother','Grandfather','Uncle','Aunt','Cousins'];

const generateUsers = (count) => {
  const users = [];
  for (let i = 1; i <= count; i++) {
    const isMale = Math.random() > 0.4;
    const firstName = isMale
      ? FIRST_NAMES_M[Math.floor(Math.random() * FIRST_NAMES_M.length)]
      : FIRST_NAMES_F[Math.floor(Math.random() * FIRST_NAMES_F.length)];
    const lastName = LAST_NAMES[Math.floor(Math.random() * LAST_NAMES.length)];
    const salaryBase = Math.floor(25 + Math.random() * 55);
    const salary = salaryBase * 1000;
    const usageMin = Math.floor(20 + Math.random() * 180);
    const heightFeet = isMale ? 5 + Math.floor(Math.random() * 2) : 5;
    const heightInch = Math.floor(Math.random() * 12);
    const weight = isMale ? 60 + Math.floor(Math.random() * 30) : 45 + Math.floor(Math.random() * 25);
    const hourlyUsage = Array.from({ length: 24 }, () => Math.floor(Math.random() * 8));
    const dayOfWeekUsage = ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'].map(day => ({
      day,
      hours: +(0.5 + Math.random() * 5.5).toFixed(1),
    }));
    const familyCount = 1 + Math.floor(Math.random() * 3);
    const familyMembers = [];
    for (let f = 0; f < familyCount; f++) {
      familyMembers.push(FAMILY[Math.floor(Math.random() * FAMILY.length)]);
    }
    const memoryCount = 2 + Math.floor(Math.random() * 2);
    const memory = [];
    for (let m = 0; m < memoryCount; m++) {
      const mem = MEMORIES[Math.floor(Math.random() * MEMORIES.length)];
      if (!memory.includes(mem)) memory.push(mem);
    }
    const prefCount = 2 + Math.floor(Math.random() * 2);
    const preferences = [];
    for (let p = 0; p < prefCount; p++) {
      const pref = PREFS[Math.floor(Math.random() * PREFS.length)];
      if (!preferences.includes(pref)) preferences.push(pref);
    }
    users.push({
      id: i,
      name: `${firstName} ${lastName}`,
      gender: isMale ? 'Male' : 'Female',
      occupation: OCCUPATIONS[Math.floor(Math.random() * OCCUPATIONS.length)],
      salary: `₹${salary.toLocaleString('en-IN')}`,
      height: `${heightFeet}'${heightInch}"`,
      weight: `${weight} kg`,
      usageTime: `${usageMin} min`,
      familyMembers,
      memory,
      preferences,
      companionPreference: COMPANIONS[Math.floor(Math.random() * COMPANIONS.length)],
      hourlyUsage,
      dayOfWeekUsage,
    });
  }
  return users;
};

const DUMMY_USERS = generateUsers(100);


const getHeatmapColor = (intensity) => {
  if (intensity >= 80) return '#166534';
  if (intensity >= 60) return '#22C55E';
  if (intensity >= 40) return '#86EFAC';
  if (intensity >= 20) return '#BBF7D0';
  return '#DCFCE7';
};

const getHeatmapTextColor = (intensity) => (intensity >= 60 ? '#fff' : '#1E293B');

const DonutChart = ({ data, size = 130, strokeWidth = 24 }) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  let cum = 0;
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      {data.map((item, i) => {
        const seg = (item.percentage / 100) * circumference;
        const offset = cum;
        cum += seg;
        return (
          <circle key={i} cx={size / 2} cy={size / 2} r={radius} fill="none"
            stroke={item.color} strokeWidth={strokeWidth}
            strokeDasharray={`${seg} ${circumference - seg}`}
            strokeDashoffset={-offset}
            transform={`rotate(-90 ${size / 2} ${size / 2})`}
            style={{ transition: 'stroke-dasharray 0.5s ease' }}
          />
        );
      })}
    </svg>
  );
};

const IndiaMap = ({ locations }) => {
  const maxCount = Math.max(...locations.map(l => l.count));
  return (
    <div className="india-map-wrapper">
      <div className="india-svg-frame">
        <IndiaSvg className="india-base" />
        {locations.map(loc => {
          const scale = loc.count / maxCount;
          return (
            <div
              key={loc.city}
              className="map-hotspot"
              style={{
                top: loc.top,
                left: loc.left,
                width: `${14 + scale * 36}px`,
                height: `${14 + scale * 36}px`,
              }}
            />
          );
        })}
      </div>
      <div className="map-legend">
        <div className="map-legend-title">User Density</div>
        <div className="map-legend-scale">
          <span className="map-legend-dot hot" /> High
          <span className="map-legend-dot med" /> Medium
          <span className="map-legend-dot low" /> Low
        </div>
      </div>
    </div>
  );
};

const UserDashboard = () => {
  const [activeTab, setActiveTab] = useState('high-level');
  const [selectedUser, setSelectedUser] = useState(DUMMY_USERS[0]);
  const [hoveredCompanion, setHoveredCompanion] = useState(null);

  const currentHour = new Date().getHours();
  const reorderedTimeUsage = [
    ...DUMMY_DATA.timeOfUsage.slice(currentHour + 1),
    ...DUMMY_DATA.timeOfUsage.slice(0, currentHour + 1),
  ];
  const maxHourly = Math.max(...DUMMY_DATA.timeOfUsage.map(t => t.users));
  const maxComp = Math.max(...DUMMY_DATA.companions.map(c => c.conversations));

  const renderHighLevel = () => (
    <div className="hl-sections">
      {/* Row 1: Stats */}
      <div className="hl-row hl-stats-row">
        <div className="glass-card stat-card">
          <div className="stat-icon">👥</div>
          <span className="stat-big-val">{DUMMY_DATA.timeOfUsage[new Date().getHours()].users.toLocaleString()}</span>
          <span className="stat-big-label">Active Now</span>
        </div>
        <div className="glass-card stat-card">
          <div className="stat-icon">🌐</div>
          <span className="stat-big-val">{DUMMY_DATA.activeUsers.total.toLocaleString()}</span>
          <span className="stat-big-label">Total Users</span>
        </div>
        <div className="glass-card stat-card">
          <div className="stat-icon">⏱️</div>
          <div className="time-display">
            <span className="time-val">{DUMMY_DATA.avgTimeSpent.minutes}</span>
            <span className="time-u">m</span>
            <span className="time-val">{DUMMY_DATA.avgTimeSpent.seconds}</span>
            <span className="time-u">s</span>
          </div>
          <span className="stat-big-label">Avg Time / Session</span>
        </div>
      </div>

      {/* Row 2: Map + Age */}
      <div className="hl-row hl-map-row">
        <div className="glass-card map-card">
          <h3>📍 User Locations — India</h3>
          <IndiaMap locations={DUMMY_DATA.demography.location} />
        </div>
        <div className="glass-card age-card">
          <h3>📊 Age Distribution</h3>
          <div className="age-bars">
            {DUMMY_DATA.demography.age.map(item => (
              <div key={item.range} className="age-col">
                <div className="age-track">
                  <div className="age-fill" style={{ height: `${item.percentage * 2.5}%` }}>
                    <span>{item.percentage}%</span>
                  </div>
                </div>
                <span className="age-label">{item.range}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Row 3: Donut Demographics */}
      <div className="hl-row">
        <div className="glass-card full-width">
          <h3>👤 Demographics</h3>
          <div className="donut-row">
            {[
              { title: 'Gender', data: DUMMY_DATA.demography.gender, key: 'type' },
              { title: 'Occupation', data: DUMMY_DATA.demography.occupation, key: 'type' },
              { title: 'Marital Status', data: DUMMY_DATA.demography.maritalStatus, key: 'status' },
              { title: 'Job Status', data: DUMMY_DATA.demography.jobStatus, key: 'status' },
            ].map(group => (
              <div key={group.title} className="donut-group">
                <h4>{group.title}</h4>
                <DonutChart data={group.data} />
                <div className="donut-legend">
                  {group.data.map(d => (
                    <div key={d[group.key]} className="legend-item">
                      <span className="legend-dot" style={{ background: d.color }} />
                      <span>{d[group.key]} {d.percentage}%</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Row 4: Hourly traffic */}
      <div className="hl-row">
        <div className="glass-card full-width">
          <h3>🕐 Time of Usage (Last 24h)</h3>
          <div className="hourly-chart">
            {reorderedTimeUsage.map((item, idx) => {
              const isCurrentHour = idx === reorderedTimeUsage.length - 1;
              return (
                <div key={`${item.hour}-${idx}`} className={`h-bar-wrap ${isCurrentHour ? 'current-hour' : ''}`} title={`${item.hour}:00 — ${item.users} users${isCurrentHour ? ' (Now)' : ''}`}>
                  <span className="h-count">{item.users}</span>
                  <div className="h-bar" style={{ height: `${(item.users / maxHourly) * 100}%` }} />
                  <span className="h-label">{item.hour}{isCurrentHour ? '*' : ''}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Row 5: Topics + Language */}
      <div className="hl-row hl-two-col">
        <div className="glass-card">
          <h3>🗣️ Conversation Topics</h3>
          <div className="heatmap-legend"><span>Cold</span><div className="legend-grad" /><span>Hot</span></div>
          <div className="topics-grid">
            {DUMMY_DATA.conversationTopics.map(item => (
              <div key={item.topic} className="topic-cell" style={{ background: getHeatmapColor(item.intensity), color: getHeatmapTextColor(item.intensity) }}>
                <span className="topic-name">{item.topic}</span>
                <span className="topic-val">{item.intensity}%</span>
              </div>
            ))}
          </div>
        </div>
        <div className="glass-card">
          <h3>🌏 Language Distribution</h3>
          <div className="lang-list">
            {DUMMY_DATA.languages.map(item => (
              <div key={item.language} className="lang-row">
                <span className="lang-name">{item.language}</span>
                <div className="lang-track">
                  <div className="lang-fill" style={{ width: `${item.percentage}%`, background: item.color }}>{item.percentage}%</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Row 6: Intent + Emotion */}
      <div className="hl-row hl-two-col">
        <div className="glass-card">
          <h3>🎯 Intent Heatmap</h3>
          <div className="intent-list">
            {DUMMY_DATA.intents.map(item => (
              <div key={item.type} className="intent-row">
                <span className="intent-icon">{item.icon}</span>
                <div className="intent-info">
                  <div className="intent-meta"><span className="intent-type">{item.type}</span><span className="intent-count">{item.count}</span></div>
                  <div className="bar-track"><div className="bar-fill-green" style={{ width: `${item.intensity}%`, background: getHeatmapColor(item.intensity) }} /></div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="glass-card">
          <h3>😊 Emotional Heatmap</h3>
          <div className="emotion-list">
            {DUMMY_DATA.emotions.map(item => (
              <div key={item.emotion} className="emotion-row" style={{ borderColor: item.color }}>
                <span className="emotion-icon">{item.icon}</span>
                <span className="emotion-name">{item.emotion}</span>
                <span className="emotion-pct" style={{ color: item.color }}>{item.percentage}%</span>
                <div className="bar-track flex-bar"><div className="bar-fill-green" style={{ width: `${item.percentage}%`, background: item.color }} /></div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Row 7: Companion Usage */}
      <div className="hl-row">
        <div className="glass-card full-width">
          <h3>🤝 Companion Usage</h3>
          <div className="comp-visual">
            <div className="comp-pie-area">
              <svg viewBox="0 0 200 200">
                {(() => {
                  let cum = 0;
                  const r = 80, cx = 100, cy = 100;
                  return DUMMY_DATA.companions.map((c, i) => {
                    const startA = (cum / 100) * 360 - 90;
                    cum += c.percentage;
                    const endA = (cum / 100) * 360 - 90;
                    const large = c.percentage > 50 ? 1 : 0;
                    const rad = Math.PI / 180;
                    const x1 = cx + r * Math.cos(startA * rad), y1 = cy + r * Math.sin(startA * rad);
                    const x2 = cx + r * Math.cos(endA * rad), y2 = cy + r * Math.sin(endA * rad);
                    const midA = ((startA + endA) / 2) * rad;
                    const lx = cx + r * 0.62 * Math.cos(midA), ly = cy + r * 0.62 * Math.sin(midA);
                    return (
                      <g key={i} onMouseEnter={() => setHoveredCompanion(c.name)} onMouseLeave={() => setHoveredCompanion(null)} style={{ cursor: 'pointer' }}>
                        <path d={`M ${cx} ${cy} L ${x1} ${y1} A ${r} ${r} 0 ${large} 1 ${x2} ${y2} Z`}
                          fill={c.color} stroke="rgba(255,255,255,0.8)" strokeWidth="2"
                          opacity={!hoveredCompanion || hoveredCompanion === c.name ? 1 : 0.35}
                          style={{ transition: 'opacity 0.3s' }} />
                        {c.percentage > 8 && <text x={lx} y={ly} textAnchor="middle" dominantBaseline="middle" fill="#fff" fontSize="10" fontWeight="600" style={{ pointerEvents: 'none' }}>{c.name}</text>}
                      </g>
                    );
                  });
                })()}
              </svg>
            </div>
            <div className="comp-legend">
              {DUMMY_DATA.companions.map(c => (
                <div key={c.name}
                  className={`comp-legend-row ${hoveredCompanion === c.name ? 'hl' : ''}`}
                  onMouseEnter={() => setHoveredCompanion(c.name)} onMouseLeave={() => setHoveredCompanion(null)}>
                  <span className="legend-dot" style={{ background: c.color }} />
                  <span className="comp-name">{c.name}</span>
                  <div className="comp-bar-track"><div className="comp-bar-fill" style={{ width: `${(c.conversations / maxComp) * 100}%`, background: c.color }} /></div>
                  <span className="comp-stat">{c.conversations.toLocaleString()} ({c.percentage}%)</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderUserData = () => (
    <div className="ud-container">
      <div className="ud-sidebar glass-card">
        <h3>Users</h3>
        <div className="ud-user-list">
          {DUMMY_USERS.map(u => (
            <div key={u.id} className={`ud-item ${selectedUser.id === u.id ? 'active' : ''}`} onClick={() => setSelectedUser(u)}>
              <div className="ud-avatar">{u.name.charAt(0)}</div>
              <div className="ud-item-info"><span className="ud-item-name">{u.name}</span><span className="ud-item-occ">{u.occupation}</span></div>
            </div>
          ))}
        </div>
      </div>
      <div className="ud-detail glass-card">
        <div className="ud-header">
          <div className="ud-avatar-lg">{selectedUser.name.charAt(0)}</div>
          <div className="ud-header-info"><h2>{selectedUser.name}</h2><span className="ud-occ">{selectedUser.occupation}</span></div>
        </div>
        <div className="ud-grid">
          <div className="info-card">
            <h4>Basic Info</h4>
            {[['Gender', selectedUser.gender], ['Salary', selectedUser.salary], ['Usage Time', selectedUser.usageTime], ['Height', selectedUser.height], ['Weight', selectedUser.weight], ['Companion', selectedUser.companionPreference]].map(([l, v]) => (
              <div key={l} className="info-row"><span className="info-label">{l}</span><span className={`info-value ${l === 'Companion' ? 'highlight' : ''}`}>{v}</span></div>
            ))}
          </div>
          <div className="info-card"><h4>Family Members</h4><div className="tag-list">{selectedUser.familyMembers.map((m, i) => <span key={i} className="tag">{m}</span>)}</div></div>
          <div className="info-card"><h4>Memory</h4><div className="tag-list">{selectedUser.memory.map((m, i) => <span key={i} className="tag memory-tag">{m}</span>)}</div></div>
          <div className="info-card"><h4>Preferences</h4><div className="tag-list">{selectedUser.preferences.map((p, i) => <span key={i} className="tag pref-tag">{p}</span>)}</div></div>
        </div>
        <div className="ud-charts">
          <div className="info-card">
            <h4>Hourly Usage Heatmap</h4>
            <div className="hourly-heatmap">
              {selectedUser.hourlyUsage.map((v, h) => (
                <div key={h} className="hm-cell" style={{ background: getHeatmapColor(v * 15) }} title={`${h}:00 — ${v} sessions`}><span>{h}</span></div>
              ))}
            </div>
          </div>
          <div className="info-card">
            <h4>Day of Week Usage</h4>
            <div className="dow-chart">
              {selectedUser.dayOfWeekUsage.map(d => (
                <div key={d.day} className="dow-col">
                  <div className="dow-bar" style={{ height: `${(d.hours / 7) * 100}%` }} />
                  <span className="dow-lbl">{d.day}</span>
                  <span className="dow-val">{d.hours}h</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderInsights = () => (
    <div className="hl-sections">
      {/* Focus Groups */}
      <div className="hl-row">
        <div className="glass-card full-width">
          <h3>🎯 Who to Focus On</h3>
          <div className="ud-focus-list">
            {DUMMY_DATA.insights.focusGroups.map((f, i) => (
              <div key={i} className="ud-focus-row">
                <div className="ud-focus-header">
                  <span className="ud-focus-group">{f.group}</span>
                  <span className={`ud-priority-badge ${f.priority.toLowerCase()}`}>{f.priority}</span>
                </div>
                <span className="ud-focus-action">→ {f.action}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Top Queries + Retention */}
      <div className="hl-row hl-two-col">
        <div className="glass-card">
          <h3>🔍 Top User Queries</h3>
          <div className="ud-query-list">
            {DUMMY_DATA.insights.topQueries.map((q, i) => (
              <div key={i} className="ud-query-row">
                <span className="ud-query-rank">#{i + 1}</span>
                <div className="ud-query-info">
                  <span className="ud-query-text">{q.query}</span>
                  <span className="ud-query-meta">{q.count.toLocaleString()} times · {q.trend === 'up' ? '📈' : q.trend === 'down' ? '📉' : '➡️'}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="glass-card">
          <h3>📊 Retention Metrics</h3>
          <div className="ud-retention-grid">
            {DUMMY_DATA.insights.retentionMetrics.map((r, i) => (
              <div key={i} className="ud-retention-card">
                <span className="ud-retention-val">{typeof r.value === 'number' && r.metric.includes('Retention') ? `${r.value}%` : r.value}</span>
                <span className="ud-retention-label">{r.metric}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Peak Insights */}
      <div className="hl-row">
        <div className="glass-card full-width">
          <h3>📈 Peak Usage Insights</h3>
          <div className="ud-peak-list">
            {DUMMY_DATA.insights.peakInsights.map((p, i) => (
              <div key={i} className="ud-peak-row">
                <span className="ud-peak-finding">{p.finding}</span>
                <div className="ud-peak-bar-track"><div className="ud-peak-bar-fill" style={{ width: `${p.relevance}%` }} /></div>
                <span className="ud-peak-val">{p.relevance}%</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Content + Companion Insights */}
      <div className="hl-row hl-two-col">
        <div className="glass-card">
          <h3>📝 Content Insights</h3>
          <div className="ud-insight-bullets">
            {DUMMY_DATA.insights.contentInsights.map((c, i) => (
              <div key={i} className="ud-insight-bullet">
                <span className="ud-bullet-icon">💡</span>
                <span>{c}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="glass-card">
          <h3>🤝 Companion Insights</h3>
          <div className="ud-insight-bullets">
            {DUMMY_DATA.insights.companionInsights.map((c, i) => (
              <div key={i} className="ud-insight-bullet">
                <span className="ud-bullet-icon">💡</span>
                <span>{c}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  const renderTab = () => {
    switch (activeTab) {
      case 'high-level': return renderHighLevel();
      case 'user-data': return renderUserData();
      case 'insights': return renderInsights();
      default: return renderHighLevel();
    }
  };

  return (
    <div className="user-dashboard">
      <header className="dash-header">
        <h1>Users Dashboard — ChaiMate</h1>
        <div className="header-meta"><span className="live-dot" /><span className="last-upd">Last 24 hours</span></div>
      </header>
      <nav className="dash-tabs">
        <button className={`tab-btn ${activeTab === 'high-level' ? 'active' : ''}`} onClick={() => setActiveTab('high-level')}>High Level Data</button>
        <button className={`tab-btn ${activeTab === 'user-data' ? 'active' : ''}`} onClick={() => setActiveTab('user-data')}>User Data</button>
        <button className={`tab-btn ${activeTab === 'insights' ? 'active' : ''}`} onClick={() => setActiveTab('insights')}>Key Insights</button>
      </nav>
      <main className="dash-main">
        {renderTab()}
      </main>
    </div>
  );
};

export default UserDashboard;
